import React, { useState } from "react";
import { Modal, Button, notification } from "antd";
import {
  LockOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import "./style.css";

const GenericModal = ({
  open,
  title = "Confirm Action",
  subtitle = "",
  highlightText = "",
  showReason = true,
  textareaLabel = "Add Reason",
  textareaPlaceholder = "Enter a reason...",
  onCancel,
  onConfirm,
  confirmText = "Confirm Lock",
  cancelText = "Go Back",
  iconColor = "#f59e0b",
  iconBgColor = "#EA580C1A",
  confirmBtnColor = "#ff8c42",
  confirmBtnHoverColor = "#e6771f",
  variant,
  confirmIcon,
}) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = () => {
    if (showReason && !reason.trim()) {
      setError("This field is required");
      return;
    }

    onConfirm(showReason ? reason : null);

    setReason("");
    setError("");
  };

  const renderSubtitle = () => {
    if (!highlightText) return subtitle;

    const parts = subtitle.split(new RegExp(`(${highlightText})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === highlightText.toLowerCase() ? (
        <strong key={index}>{part}</strong>
      ) : (
        part
      ),
    );
  };
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      className={`confirm-modal ${variant === "success" ? "confirm-modal--success" : ""}`}
    >
      <div className="top-gradient"></div>
      <div className="confirm-modal-body">
        <div className="confirm-header">
          <div
            className="confirm-icon-wrapper"
            style={{ backgroundColor: iconBgColor }}
          >
            <ExclamationCircleOutlined
              className="confirm-icon"
              style={{ color: iconColor, fontSize: "20px" }}
            />
          </div>

          <div className="confirm-title-container">
            <div className="confirm-title">{title}</div>
            {subtitle && (
              <div className="confirm-subtitle">{renderSubtitle()}</div>
            )}
          </div>
        </div>

        {showReason && (
          <>
            <label className="textarea-label">{textareaLabel}</label>
            <textarea
              className="confirm-textarea"
              placeholder={textareaPlaceholder}
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
                if (error) setError("");
              }}
            ></textarea>
            {error && <div className="textarea-error">{error}</div>}
          </>
        )}

        <div className="confirm-buttons">
          <Button className="btn-cancel" onClick={onCancel}>
            {cancelText}
          </Button>
          <Button
            className="btn-confirm"
            style={{
              backgroundColor: confirmBtnColor,
              borderColor: confirmBtnColor,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = confirmBtnHoverColor;
              e.currentTarget.style.borderColor = confirmBtnHoverColor;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = confirmBtnColor;
              e.currentTarget.style.borderColor = confirmBtnColor;
            }}
            onClick={handleConfirm}
          >
            {confirmIcon ??
              (variant === "success" ? (
                <CheckCircleOutlined />
              ) : (
                <LockOutlined />
              ))}{" "}
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default GenericModal;
